<template>
  <div align="left">
    <b-table-simple>
      <b-tr>
        <b-td width="10%">Size in bits:</b-td>
        <b-td width="10%"><b-form-input v-model="size" type="number" :min="0" :max="128"/></b-td>
        <b-td><b-form-input v-model="decimalValue" :state="decimalValid" placeholder="Enter an integer value"/></b-td>
      </b-tr>
    </b-table-simple><p/>

    <b-card title="Sign Extension">
      <div class="conv-number" :hidden="!decimalValid">{{this.twosComplement}}</div>
    </b-card>
  </div>
</template>

<script>
import {Numbers} from '@/util/numbers'

export default {
  name: 'represnetations',
  data () {
    return {
      size: 8,
      complement: false
    }
  },
  mixins: [Numbers],
  methods: {
    computeOnesComplement: function (value) {
      let sign = Math.sign(value)
      let bits = value.toString(2)
      if (sign !== -1) {
        bits = '0'.repeat(this.size - bits.length) + bits
      } else {
        bits = ((~Math.abs(this.decimalInt)) >>> 0).toString(2)
        bits = bits.substring(bits.length - this.size)
      }
      return bits
    },
    computeTwosComplement: function (value) {
      let sign = Math.sign(value)
      let bits = (value >>> 0).toString(2)
      if (bits.length < this.size) {
        bits = (sign !== -1 ? '0' : '1').repeat(this.size - bits.length) + bits
      } else if (bits.length > this.size) {
        bits = bits.substring(bits.length - this.size)
      }
      return bits
    }
  },
  computed: {
    signedMagnitude: function () {
      let sign = Math.sign(this.decimalInt)
      let bits = this.toBinary(sign * this.decimalInt)
      let bitsLength = bits.length

      if (bitsLength > this.size) {
        this.size = bitsLength + 1
      }

      return (sign !== -1 ? '0' : '1') + '0'.repeat(this.size - bitsLength - 1) + bits
    },
    signedMagnitudeComplement: function () {
      return (this.signedMagnitude[0] === '1' ? '0' : '1') + this.signedMagnitude.substring(1)
    },
    onesComplement: function () {
      return this.computeOnesComplement(this.decimalInt)
    },
    onesComplementComplement: function () {
      return this.computeOnesComplement(-1 * this.decimalInt)
    },
    twosComplement: function () {
      return this.computeTwosComplement(this.decimalInt)
    },
    twosComplementComplement: function () {
      return this.computeTwosComplement(-1 * this.decimalInt)
    }
  }
}
</script>

<style>
.conv-number {
  font-family: monospace;
  font-size: x-large;
}
</style>


// WEBPACK FOOTER //
// src/components/sign-extension.vue